import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import TabNavigation from '../components/TabNavigation';
import DataManagementPage from './DataManagementPage';
import DatasetPage from './DatasetPage';
import '../styles/dashboard-pages.css';

const DataPage: React.FC = () => {
  const tabs = [
    { path: '/dashboard/data/management', label: 'Data', icon: '📁' },
    { path: '/dashboard/data/datasets', label: 'Datasets', icon: '📊' },
  ];

  return (
    <div className="dashboard-page">
      <div className="page-header">
        <h1>Data</h1>
        <p>Upload, organize, and manage your data and datasets</p>
      </div>
      
      <TabNavigation tabs={tabs} basePath="/dashboard/data" />
      
      <Routes>
        <Route path="/" element={<Navigate to="/dashboard/data/management" replace />} />
        <Route path="/management" element={<DataManagementPage />} />
        <Route path="/datasets" element={<DatasetPage />} />
      </Routes>
    </div>
  );
};

export default DataPage;
